import React from "react";
import useGetListOptionHook from "../hooks/useGetListOptionHook";
import { ListOption } from "../data/ListOption";
import useGetDeviceHook from "../hooks/useGetDeviceHook";
import { Device } from "../data/Device";

type DevicesContextProps = {
    listOptions: ListOption[] | undefined;
    isListOptionFetching: boolean;
    refetchListOption: () => void;
    devices: Device[] | undefined;
    isDevicesFetching: boolean;
    refetchDevices: () => void;
};

const DeviceContext = React.createContext<DevicesContextProps>(null!);

export function DevicesProvider({ children }: { children: React.ReactNode }) {
    const { listOptions, isListOptionFetching, refetchListOption } = useGetListOptionHook();
    const { devices, isDevicesFetching, refetchDevices } = useGetDeviceHook();

    return (
        <DeviceContext.Provider value={{
            listOptions, isListOptionFetching, refetchListOption,
            devices, isDevicesFetching, refetchDevices
        }}>
            {children}
        </DeviceContext.Provider>
    );
}

export function useDevicesContext() {
    return React.useContext(DeviceContext);
}